import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  field: {
    display: 'flex',
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
  textField: {
    border: `1px solid ${theme.palette.grey[200]}`,
    '& > div': {
      '&::before, &::after': {
        content: 'none',
      },
      '& > input': {
        padding: 0,
      },
    },
  },
}));
